import { useEffect } from 'react';

// Traps browser Back/Forward on the current page by seeding an extra history
// entry and re-pushing on every popstate. React Router's own pushState from
// <Link>/navigate() still works — only the browser chrome buttons are pinned.
export default function useDisableBrowserNav() {
  useEffect(() => {
    window.history.pushState(null, '', window.location.href);

    const handlePopState = () => {
      window.history.pushState(null, '', window.location.href);
    };

    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);
}
